import {Component, Input} from '@angular/core';
import {CheckBoxModule, SwitchModule} from "@syncfusion/ej2-angular-buttons";
import {TranslatePipe} from "../../pipes/translate.pipe";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";

@Component({
    selector: 'app-form-switch',
    imports: [
        SwitchModule,
        TranslatePipe,
        FormsModule,
        CheckBoxModule,
        ReactiveFormsModule
    ],
    templateUrl: './form-switch.component.html',
    styleUrl: './form-switch.component.scss'
})
export class FormSwitchComponent {
  @Input() public fCN: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public onLabel: string = 'ON';
  @Input() public offLabel: string = 'OFF';
}
